import { Grid, IconButton, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography } from "@mui/material";
import AdminSidebar from "./Sidebar";
import axios from 'axios';
import { useEffect, useState } from "react";
import { Delete, Edit } from "@mui/icons-material";
export default function Categoties() {

    var url = `http://localhost:${process.env?.PORT || 3000}/`


    const [categories, setCategories] = useState([]);
    const [loading, setLoading] = useState(false);

    async function fetchCategories() {
        try {
            setLoading(true);

            const response = await axios.post(url + 'admin/categories/fetch');

            if (response.data.response === "success") {
                setCategories(response.data.data || []);
            } else {
                alert(response.data.reason);
            }
        } catch (error) {
            console.error("Fetch Categories Error:", error);
            alert("Failed to fetch categories.");
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchCategories();
    }, []);

    async function addCategory(e) {
        e.preventDefault();

        const formData = new FormData(e.currentTarget);
        const name = formData.get("name")?.trim();

        if (!name) {
            alert("Category name is required.");
            return;
        }


        try {
            setLoading(true);

            const response = await axios.post(
                `${url}admin/categories/add`,
                {
                    name,
                }
            );

            if (response.data.response === "success") {
                await fetchCategories();

                e.target.reset();

                if (e.target.name) {
                    e.target.name.focus();
                }
            } else {
                alert(response.data.reason);
            }
        } catch (error) {
            console.error("Add Category Error:", error);
            alert("Failed to add category.");
        } finally {
            setLoading(false);
        }
    };

    async function deleteCategory(id) {
        const confirmed = window.confirm(
            "Are you sure you want to delete this category?"
        );

        if (!confirmed) return;

        try {
            setLoading(true);

            const response = await axios.post(
                `${url}admin/categories/delete`,
                {
                    Id: id,
                }
            );

            if (response.data.response === "success") {
                setCategories((prev) =>
                    prev.filter((category) => category._id !== id)
                );
            } else {
                alert(response.data.reason);
            }
        } catch (error) {
            console.error("Delete Category Error:", error);
            alert("Failed to delete category.");
        } finally {
            setLoading(false);
        }
    };


    return (
        <>

            <Grid container height={'100vh'}
                // className='admin-body'
                width={'100%'}>
                <AdminSidebar />

                <Grid height={'100vh'} container justifyContent={'space-between'} alignItems={'flex-start'} size={{ lg: 10 }} px={3} p={3}>
                    <Grid size={{ lg: 4 }} className="bg-admin-navy p-3 rounded shadow text-white">
                        <Typography variant="h6" className="fw-bold">Add Category</Typography>
                        {/* <div className="p-3 bar-cont mt-2"> */}
                        <form className="form" onSubmit={addCategory}>
                            <input required type="text" name="name" placeholder="Category Name" className="form-control mt-3" />
                            <button type="submit" className="btn-admin w-100 mt-3 py-1">Submit</button>
                        </form>
                        {/* <Bar data={data} className="position-relative" options={options} /> */}
                        {/* <Bar data={data} className="position-relative" options={options} /> */}
                        {/* </div> */}
                    </Grid>
                    <Grid size={{ lg: 7 }}>
                        <TableContainer sx={{ background: '#0F1536', color: 'white', borderRadius: 2 }}>
                            <Table aria-label="caption table">
                                {/* <caption>A basic table example with a caption</caption> */}
                                <TableHead>
                                    <TableRow>
                                        <TableCell className="text-white">Name</TableCell>
                                        <TableCell className="text-white">Slug</TableCell>
                                        <TableCell align="center" className="text-white">Active</TableCell>
                                        <TableCell align="center" className="text-white">Actions</TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {categories?.map((row, index) => (
                                        <TableRow key={index}>
                                            <TableCell className="text-white" component="th" scope="row">
                                                {row.Name}
                                            </TableCell>
                                            <TableCell className="text-white">{row.Slug}</TableCell>
                                            <TableCell align="center" className="text-green">Yes</TableCell>
                                            {/* <TableCell className="text-white"><button className=" btn-outline-white">View</button></TableCell> */}
                                            <TableCell className="text-white d-flex justify-content-evenly">
                                                <IconButton onClick={() => deleteCategory(row._id)} color="inherit">
                                                    <Delete />
                                                </IconButton>
                                                <IconButton color="inherit">
                                                    <Edit />
                                                </IconButton>
                                            </TableCell>
                                        </TableRow>
                                    ))}
                                </TableBody>
                            </Table>
                        </TableContainer>
                    </Grid>
                </Grid>

            </Grid>

        </>
    )

}